export function attachWarehouseVisit(section) {
  const dialog = section.querySelector('[data-warehouse-visit-dialog]');
  const trigger = section.querySelector('[data-warehouse-visit-open]');
  if (!dialog || !trigger || typeof dialog.showModal !== 'function') return () => {};
  const doc = section.ownerDocument, view = doc.defaultView;
  const close = dialog.querySelector('[data-warehouse-visit-close]');
  const form = dialog.querySelector('form');
  const listeners = [];
  let previousOverflow = '', opener = null, ownsScrollLock = false, autoShown = false;
  const on = (target, type, handler) => { target?.addEventListener(type, handler); listeners.push(() => target?.removeEventListener(type, handler)); };
  const open = () => {
    if (dialog.open || doc.querySelector('dialog[open]')) return false;
    previousOverflow = doc.body.style.overflow; opener = trigger;
    try { dialog.showModal(); } catch { opener = null; return false; }
    doc.body.style.overflow = 'hidden'; ownsScrollLock = true; autoShown = true;
    const response = dialog.querySelector('[data-contact-response]:not([hidden])');
    (response || close)?.focus({ preventScroll: true });
    return true;
  };
  const release = () => {
    if (dialog.open) return;
    if (ownsScrollLock) { doc.body.style.overflow = doc.querySelector('dialog[open]') ? 'hidden' : previousOverflow; ownsScrollLock = false; }
    if (opener?.isConnected && !doc.querySelector('dialog[open]')) opener.focus({ preventScroll: true });
    opener = null;
  };
  const autoOpen = () => {
    if (autoShown || dialog.open || !section.isConnected) return;
    let hash = ''; try { hash = decodeURIComponent(view?.location.hash.slice(1) || ''); } catch (_) {}
    // The existing native response controller decides which form owns a result.
    // Do not expose a hidden result belonging to another contact form.
    if (dialog.querySelector('[data-contact-response]:not([hidden])') || hash === 'warehouse-booking' || form?.id && hash === form.id) open();
  };
  on(trigger, 'click', event => {
    if (event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    if (open()) event.preventDefault();
  });
  on(close, 'click', () => dialog.close());
  on(dialog, 'cancel', event => { event.preventDefault(); dialog.close(); });
  on(dialog, 'close', release);
  on(dialog, 'click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  on(view, 'hashchange', () => { autoShown = false; autoOpen(); });
  if (doc.readyState === 'loading') on(doc, 'DOMContentLoaded', autoOpen); else autoOpen();
  const observer = typeof MutationObserver === 'function' ? new MutationObserver(autoOpen) : null;
  observer?.observe(dialog, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  return () => {
    observer?.disconnect();
    if (dialog.open) dialog.close();
    listeners.splice(0).forEach(remove => remove()); release();
  };
}

const mounted = new Map();
export function initWarehouseVisit(scope) {
  if (!scope?.querySelectorAll) return;
  const sections = [...scope.querySelectorAll('[data-warehouse-visit]')];
  if (scope.matches?.('[data-warehouse-visit]')) sections.unshift(scope);
  for (const section of sections) if (!mounted.has(section)) mounted.set(section, attachWarehouseVisit(section));
}
export function unloadWarehouseVisit(scope) {
  for (const [section, destroy] of mounted) if (section === scope || scope?.contains?.(section)) { destroy(); mounted.delete(section); }
}
if (typeof document !== 'undefined') {
  initWarehouseVisit(document);
  document.addEventListener('shopify:section:load', event => initWarehouseVisit(event.target));
  document.addEventListener('shopify:section:unload', event => unloadWarehouseVisit(event.target));
}
